import { render } from "./AuthorDetail.vue?vue&type=template&id=7c6bce5a&scoped=true&ts=true"
import script from "./AuthorDetail.vue?vue&type=script&lang=ts"
export * from "./AuthorDetail.vue?vue&type=script&lang=ts"

import "./AuthorDetail.vue?vue&type=style&index=0&id=7c6bce5a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c6bce5a"]])

export default __exports__